import { useState } from 'react';
import { useDrawerUrlFlag } from '../../hooks/useDrawerUrlFlag';
import { ALL_KNOWN_DETAILS_DRAWER_PARAM, KNOWN_DETAIL_TAB_ORDER } from '../constants';
import type { KnownDetailType } from '../types';

export const useAllKnownDetailsDrawer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeType, setActiveType] = useState<KnownDetailType>(KNOWN_DETAIL_TAB_ORDER[0]);

    useDrawerUrlFlag(isOpen, ALL_KNOWN_DETAILS_DRAWER_PARAM);

    const openDrawer = (type: KnownDetailType = KNOWN_DETAIL_TAB_ORDER[0]) => {
        setActiveType(type);
        setIsOpen(true);
    };

    return { isOpen, activeType, openDrawer, closeDrawer: () => setIsOpen(false), setActiveType };
};
